export default __webpack_public_path__ + "static/media/copy_simple.2995c784.svg";